import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TextColorIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "TextColor",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M6.22 29.9a1.608 1.608 0 0 0 2.07-.96s2.01-5.45 2.01-5.45h11.35l2.01 5.44c.23.63.83 1.08 1.54 1.08a1.63 1.63 0 0 0 1.53-2.19S17.53 2.9 17.53 2.9v-.06l-.1-.15-.08-.14-.1-.13-.1-.12-.18-.08-.11-.09-.16-.09-.13-.06h-1.26l-.12.06-.16.09-.03.09-.14.12-.1.11-.1.13-.08.14-.08.15v.06L5.24 27.82a1.608 1.608 0 0 0 .96 2.07h.01ZM16 8.1l4.47 12.11h-8.94z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M22.71 30.48c-.48 0-.94-.3-1.12-.78L12.86 6.4 4.12 29.71a1.195 1.195 0 1 1-2.24-.84l9.86-26.29c.17-.47.62-.78 1.12-.78s.94.31 1.12.78l9.86 26.29c.23.62-.08 1.31-.7 1.54-.14.05-.28.08-.42.08Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.29 21.29H6.43a1.14 1.14 0 1 1 0-2.28h12.86a1.14 1.14 0 1 1 0 2.28M28.14 9.4c0 1.52-1.23 2.74-2.74 2.74s-2.74-1.23-2.74-2.74S25.4 3 25.4 3s2.74 4.89 2.74 6.4"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.4 13.29c-2.14 0-3.89-1.74-3.89-3.88 0-1.68 2.21-5.75 2.89-6.96.2-.36.58-.58 1-.58.41 0 .79.22 1 .58.68 1.21 2.89 5.28 2.89 6.96 0 2.14-1.74 3.88-3.88 3.88Zm0-7.86c-.88 1.74-1.6 3.43-1.6 3.97 0 .88.72 1.6 1.6 1.6s1.6-.72 1.6-1.6c0-.53-.72-2.22-1.6-3.97"
      })]
    })
  }));
};
TextColorIcon.displayName = 'TextColorIcon';